<div class="billing-supplier">
    <app-header
        [title]="'support.faturamento-fornecedores.header.titulo' | translate"
        [hasBackButton]="false"
        [hasSearchButton]="false"
        [searchInput]="filter"
        [searchPlaceholder]="'support.faturamento-fornecedores.header.filtro' | translate"
        (onSearch)="onSearch($event)"
    >
        @if (isOnEmailPage && billingSupplierLastEmailExecution) {
            <div class="general-last-billing">
                <b>{{ 'support.faturamento-fornecedores.header.infos.last-billing.title.email' | translate }}</b>
                {{ billingSupplierLastEmailExecution | date: 'dd/MM/yyyy' }}
                <small>{{ billingSupplierLastEmailExecution | date: 'HH:mm:ss' }}</small>
            </div>
        }

        @if (isOnEmailPage && billingSupplierTotalQuantity) {
            <div class="general-status">
                <b>{{ 'support.faturamento-fornecedores.header.infos.status.title' | translate }}</b>
                <span>{{ 'support.faturamento-fornecedores.header.infos.status.successes.email' | translate: { successes: billingSupplierSuccessEmailQuantity, total: billingSupplierTotalQuantity } }}</span>
                <small>{{ 'support.faturamento-fornecedores.header.infos.status.errors' | translate: { errors: billingSupplierErrorEmailQuantity } }}</small>
            </div>
        }

        @if (!isOnEmailPage && billingSupplierLastExecution) {
            <div class="general-last-billing">
                <b>{{ 'support.faturamento-fornecedores.header.infos.last-billing.title.billing' | translate }}</b>
                {{ billingSupplierLastExecution | date: 'dd/MM/yyyy' }}
                <small>{{ billingSupplierLastExecution | date: 'HH:mm:ss' }}</small>
            </div>
        }

        @if (!isOnEmailPage && billingSupplierTotalQuantity) {
            <div class="general-status">
                <b>{{ 'support.faturamento-fornecedores.header.infos.status.title' | translate }}</b>
                <span>{{ 'support.faturamento-fornecedores.header.infos.status.successes.billing' | translate: { successes: billingSupplierSuccessQuantity, total: billingSupplierTotalQuantity } }}</span>
                <small>{{ 'support.faturamento-fornecedores.header.infos.status.errors' | translate: { errors: billingSupplierErrorQuantity } }}</small>
            </div>
        }

        <button customButton styleType="primary" [isLoading]="false" label="support.faturamento-fornecedores.header.buttons.atualizar" (click)="loadScreen()" [outline]="true" iconName="refresh-cw" ></button>

        @if (isOnEmailPage) {
            <button customButton styleType="primary" [isLoading]="false" label="support.faturamento-fornecedores.header.buttons.email.title" (click)="executeAllEmails()" iconName="mail" [isDisabled]="hadAlreadySentEmails"></button>
        } @else {
            <button customButton styleType="primary" [isLoading]="false" label="support.faturamento-fornecedores.header.buttons.faturar.title" (click)="executePendingBilling()"></button>
        }

    </app-header>
    <div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
        <div class="corpo-pagina">
            <div class="card card-default">
                <app-support-gridview [config]="config" [templates]="templatesArray" (onAction)="executeSelectedBilling($event.item)" [hasLineClick]="true"  (onLineClick)="billingHoldingDetailModal.open($event)"></app-support-gridview>

                <ng-template #paymentTypeTemplate let-item>
                    <div class="payment-type-group">
                        {{ item.commissionPayable | currency:'R$' }}
                        <small>{{ item.paymentTypeDescription }}</small>
                    </div>
                </ng-template>

                <ng-template #lastDateTemplate let-item>
                    <div class="last-date-group">
                        @if ((isOnEmailPage ? item.lastEmail : item.lastBilling) != null) {
                            {{ (isOnEmailPage ? item.lastEmail : item.lastBilling) | date: 'dd/MM/yyyy' }}
                            <small>{{ (isOnEmailPage ? item.lastEmail : item.lastBilling) | date: 'HH:mm:ss' }}</small>
                        } @else {
                            -
                        }
                    </div>
                </ng-template>

                <ng-template #statusTemplate let-item>
                    <div class="pill-label" [ngClass]="isOnEmailPage ? item.statusEmailClass : item.statusClass" [tooltip]="isOnEmailPage ? item.errorEmailMessage : item.errorMessage">
                        {{ isOnEmailPage ? item.statusEmailDescription : item.statusDescription}}
                    </div>
                </ng-template>
            </div>
        </div>
        <footer>
            <p>{{ isOnEmailPage ? null : 'support.faturamento-fornecedores.footer.text.' + ( canSendEmails ? 'info' : 'warning') | translate }}</p>
            <button customButton styleType="secondary" [label]="'support.faturamento-fornecedores.footer.buttons.' + (isOnEmailPage ? 'billing' : 'email')" [iconName]="'arrow-' + (isOnEmailPage ? 'left' : 'right')" [isLoading]="false" [isDisabled]="!canSendEmails" (click)="changePage()"></button>
        </footer>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<app-billing-supplier-detail #templateBillingSupplierDetail></app-billing-supplier-detail>
